import React from 'react';
import Section from 'core/components/section';
import { useFormikContext } from 'formik';
import { paymentMethod } from '@ourbranch/lookups';

import { BillingForm } from './billing-form';

const BillingInformation = () => {
  const { values } = useFormikContext();

  const isDirectPay = [values.farmPaymentMethod, values.autoPaymentMethod].includes(paymentMethod.Direct);
  return (
    <Section title={`${isDirectPay ? 'Customer' : 'Billing'} Address`} type="SubSection">
      <BillingForm />
    </Section>
  );
};

export default BillingInformation;
